// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[4].use[1]!../../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[4].use[2]!../../styles/common.module.css");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.big-play-button_button__ASbwy {

  position: absolute;
  z-index: 1;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  aspect-ratio: 1;
  width: auto;
  height: min(27%, 129px);
  border-radius: 50%;

  transition: opacity 0.2s;

  -webkit-tap-highlight-color: transparent;
}

@media (prefers-contrast: more) {
    .big-play-button_button__ASbwy {
      border: 1px solid var(--bigPlayButtonIconColor);
    }
  }

.big-play-button_button__ASbwy svg {
  width: 100%;
  height: 100%;
}

.big-play-button_button__ASbwy circle {
  fill: var(--primaryColor);
}

.big-play-button_button__ASbwy path {
  fill: var(--bigPlayButtonIconColor);
}

@media (any-hover: hover) {
  .big-play-button_button__ASbwy:hover circle {
    fill: var(--bigPlayButtonIconColor);
  }

  .big-play-button_button__ASbwy:hover path {
    fill: var(--primaryColor);
  }
}

@media (prefers-reduced-motion) {
  .big-play-button_button__ASbwy {
    transition: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/big-play-button/big-play-button.module.css"],"names":[],"mappings":"AAAA;;EAGE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;EACT,gCAAgC;;EAEhC,eAAe;EACf,WAAW;EACX,uBAAuB;EACvB,kBAAkB;;EAElB,wBAAwB;;EAExB,wCAAwC;AAO1C;;AALE;IACE;MACE,+CAA+C;IACjD;EACF;;AAGF;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE;IACE,mCAAmC;EACrC;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".button {\n  composes: button from '../../styles/common.module.css';\n\n  position: absolute;\n  z-index: 1;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n\n  aspect-ratio: 1;\n  width: auto;\n  height: min(27%, 129px);\n  border-radius: 50%;\n\n  transition: opacity 0.2s;\n\n  -webkit-tap-highlight-color: transparent;\n\n  @media (prefers-contrast: more) {\n    & {\n      border: 1px solid var(--bigPlayButtonIconColor);\n    }\n  }\n}\n\n.button svg {\n  width: 100%;\n  height: 100%;\n}\n\n.button circle {\n  fill: var(--primaryColor);\n}\n\n.button path {\n  fill: var(--bigPlayButtonIconColor);\n}\n\n@media (any-hover: hover) {\n  .button:hover circle {\n    fill: var(--bigPlayButtonIconColor);\n  }\n\n  .button:hover path {\n    fill: var(--primaryColor);\n  }\n}\n\n@media (prefers-reduced-motion) {\n  .button {\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `big-play-button_button__ASbwy ${___CSS_LOADER_ICSS_IMPORT_0___.locals["button"]}`
};
module.exports = ___CSS_LOADER_EXPORT___;
